// One relieve/replace control for a person slot (the room's CRNA, or its
// supervising doctor). Lifted out of TimelineCaseModal.js unchanged in
// behaviour — the file was already over the 500-line house limit before a
// second CRNA was added to it.
//
// travelFacilities (CRNA slot only): enables the 🚗 Travel disposition with a
// destination-facility dropdown (Tampa / Carrollwood / Wesley Chapel minus the
// current campus).
//
// ⚠️ `currentName` MUST BE THE SEAT, NOT THE RAW CELL. On a legacy orienting row
// `ahpName` still reads "Trevor Stamand 5 orient Kayla Gibbons", and this
// component prints it three times: the slot header, the "— keep … —" option in
// the Replace dropdown, and the "Relieved … →" line. That is exactly what the
// product owner photographed on 2026-08-18. The caller resolves the seat.
import React from "react";
import st from "./caseModalStyles";

export default function PersonSlot({
  kind,
  currentName,
  pool,
  replId,
  setReplId,
  disposition,
  setDisposition,
  travelFacilities = null,
  travelDest = "",
  setTravelDest = null,
}) {
  if (!currentName) return null;
  const dispositions = travelFacilities ? ["unassigned", "home", "travel"] : ["unassigned", "home"];
  const dispoLabel = { unassigned: "↩ Unassigned", home: "🏠 Home", travel: "🚗 Travel" };
  return (
    <div style={st.slot}>
      <div style={st.slotHead}>
        <span style={st.slotKind}>{kind}</span>
        <span style={st.slotName}>{currentName}</span>
      </div>
      <label style={st.field}>
        {/* ⚠️ NAMED, NOT "Replace with". Two people can be in this room and both
            can be replaced; a label that does not say WHO is the one-verb-two-
            actions failure this repo already has a scar for. */}
        {`Replace ${currentName} with`}
        <select
          style={st.select}
          aria-label={`Replace ${currentName} with`}
          value={replId}
          onChange={(e) => setReplId(e.target.value)}
        >
          <option value="">— keep {currentName} —</option>
          {pool.map((p) => (
            <option key={p.id} value={p.id}>{(p.shortCode ? `${p.shortCode} — ` : "") + p.name}</option>
          ))}
        </select>
      </label>
      <div style={st.dispoRow} role="radiogroup" aria-label={`Send relieved ${currentName} to`}>
        <span style={st.dispoLabel}>Relieved {currentName} →</span>
        {dispositions.map((d) => (
          <button
            key={d}
            type="button"
            role="radio"
            aria-checked={disposition === d}
            onClick={() => setDisposition(d)}
            style={{ ...st.dispoBtn, ...(disposition === d ? st.dispoBtnOn : {}) }}
          >
            {dispoLabel[d]}
          </button>
        ))}
      </div>
      {travelFacilities && disposition === "travel" && (
        <label style={st.field}>
          Traveling to
          <select
            style={st.select}
            value={travelDest}
            onChange={(e) => setTravelDest(e.target.value)}
            aria-label={`Destination facility for ${currentName}`}
          >
            <option value="">Select a facility…</option>
            {travelFacilities.map((f) => (
              <option key={f.id} value={f.id}>{f.label}</option>
            ))}
          </select>
        </label>
      )}
    </div>
  );
}
